import type { AnnieDemoReplacement } from "../../hooks/useAnnie";

/** Wait before each simulated reply (lands at 3s, 8s, 13s). */
const REPLY_GAPS_MS = [3_000, 5_000, 5_000];

/** One reply per contacted nurse: every decline, then the acceptance. */
export const demoReplyCount = (replacement: AnnieDemoReplacement): number => replacement.declined.length + 1;

/** When reply `index` lands, counted from the approval. */
export const demoReplyArrivalMs = (index: number): number =>
	// DEFAULT: past the last gap, keep the final pace rather than stall the search.
	Array.from({ length: index + 1 }, (_, reply) => REPLY_GAPS_MS[Math.min(reply, REPLY_GAPS_MS.length - 1)]).reduce((total, gap) => total + gap, 0);

/** When the acceptance lands — the moment the schedule should show the swap. */
export const demoAcceptedAtMs = (replacement: AnnieDemoReplacement): number => demoReplyArrivalMs(demoReplyCount(replacement) - 1);
